import React, { useState, useEffect } from "react";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import DataTable from "react-data-table-component";
import axios from "axios";
import { checkUserPermission } from "../../../../common/UserPermission";
import Loader from "../../../../components/Loader/Loader";
import config from "../../../../config/config";
import moment from "moment";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useMemo } from "react";
import { toastSuccess } from "../../../../common/Toast";
import {
  DELETE_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import CommonMatrialReactTableServerSideRender from "../../../../components/Datatable/CommonMatrialReactTableServerSideRender";
import { handleSaveColumnOrder } from "../../../../common/common";

export const Journal = () => {
  let PERMISSION_ADD = "/journal-entry";
  let PERMISSION_EDIT = "/journal-entry/:id";
  let PERMISSION_DELETE = "delete-journal-entry";
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");

  const [searchtext, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");

  const [customStartingDate, setCustomStartingDate] = useState();
  const loginuserid = localStorage.getItem("ID");
  const [customEndingDate, setCustomEndingDate] = useState();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [perPage, setPerPage] = useState(25);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [sortingId, setSortingId] = useState(4);
  const [mappeddata, setMappedData] = useState([]);
  const [showDateFilterModal, setShowDateFilterModal] = useState(false);

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const deleteRequestParam = localStorage.getItem("DeleteRequestParam");

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);

  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    if (field === "AllData") {
      Data = data;
    } else {
      Data = filterData?.map((el) => el?.original);
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_File.xlsx`);
  };

  const navigate = useNavigate();

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      size: 120,
      Cell: checkUserPermission(PERMISSION_EDIT)
        ? ({ row }) => (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              })}
              onClick={() => navigate(`/journal-entry/${row.original.ID}`)}
            >
              {row.original.ID}
            </Box>
          )
        : null,
      filterFn: "contains",
    },
    {
      header: "Journal No",
      accessorKey: "JournalNo",
    },
    {
      header: "Journal Date",
      accessorKey: "JournalDate",
      Cell: ({ row }) => {
        return moment(row.original.JournalDate).format("MM/DD/YYYY");
      },
    },
    {
      header: "Created On",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format("MM/DD/YYYY h:mm A"),
    },
    {
      header: "Debit Amount",
      accessorKey: "TotalDebitAmount",
    },
    {
      header: "Credit Amount",
      accessorKey: "TotalCreditAmount",
    },
    {
      header: "Memo",
      accessorKey: "Memo",
    },
    {
      header: "SyncDate",
      accessorKey: "SyncDate",
      // size: 140,
      Cell: ({ row }) =>
        moment(row.original.SyncDate).format("MM/DD/YYYY h:mm A"),
    },
    {
      header: "Quickbook SyncStatus",
      accessorKey: "SyncStatus",
      size: 110,
      Cell: ({ row }) =>
        row.original.SyncStatus == "Completed" ? (
          <Box
            // class="text-warning word-break-data"
            // to={`/manage-suppliers/${row.original.SupplierId}`}
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#E8F7F5',
              borderRadius: "0.3rem",
              color: "var(--success-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatus}
          </Box>
        ) : row.original.SyncStatus == "Failed" ? (
          <Box
            component="span"
            sx={(theme) => ({
              //  backgroundColor: '#FEF7E2',
              borderRadius: "0.3rem",
              color: "var(--error-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatus}
          </Box>
        ) : (
          ""
        ),
    },
  ]);

  const handleQuickBookChange = (fieldName, event) => {
    // console.log("Value ==> ", event);
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      var currentDateForLastWeek = new Date();
      // console.log("currentDateForLastWeek ==> ", currentDateForLastWeek);
      // Set the date to the start of the current week (Sunday)
      var startOfWeekForLastWeek = new Date(
        currentDateForLastWeek.setDate(
          currentDateForLastWeek.getDate() - currentDateForLastWeek.getDay()
        )
      );
      // console.log("startOfWeekForLastWeek ==> ", startOfWeekForLastWeek);

      // Set the date to the end of the last week (Saturday)
      var endOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(startOfWeekForLastWeek.getDate() - 1)
      );
      // console.log("endOfLastWeekForLastWeek ==> ", endOfLastWeekForLastWeek);

      // Set the date to the start of the last week (Sunday)
      var startOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(endOfLastWeekForLastWeek.getDate() - 6)
      );

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForLastWeek = startOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      var endDateStringForLastWeek = endOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      // Output the results
      // console.log(
      //   "Last week started on " +
      //     startDateStringForLastWeek +
      //     " and ended on " +
      //     endDateStringForLastWeek
      // );
      setStartingDate(startDateStringForLastWeek);
      setEndingDate(endDateStringForLastWeek);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      var currentDateForCurrentWeek = new Date();
      // console.log("currentDateForCurrentWeek ==> ", currentDateForCurrentWeek);

      // Set the date to the start of the current week (Sunday)
      var startOfWeekForCurrentWeek = new Date(
        currentDateForCurrentWeek.getTime() -
          currentDateForCurrentWeek.getDay() * 24 * 60 * 60 * 1000
      );
      // console.log("startOfWeekForCurrentWeek ==> ", startOfWeekForCurrentWeek);

      // Set the date to the end of the current week (Saturday)
      var endOfWeekForCurrentWeek = new Date(
        startOfWeekForCurrentWeek.getTime() + 6 * 24 * 60 * 60 * 1000
      );
      // console.log("endOfWeekForCurrentWeek ==> ", endOfWeekForCurrentWeek);

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForCurrentWeek = startOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      var endDateStringForCurrentWeek = endOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   "Current week started on " +
      //     startDateStringForCurrentWeek +
      //     " and ended on " +
      //     endDateStringForCurrentWeek
      // );

      setStartingDate(startDateStringForCurrentWeek);
      setEndingDate(endDateStringForCurrentWeek);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      // Get today's date
      const todayForLastMonth = new Date();

      // Get the first day of the current month
      const firstDayCurrentMonthForLastMonth = new Date(
        todayForLastMonth.getFullYear(),
        todayForLastMonth.getMonth(),
        1
      );

      // Get the last day of the previous month
      const lastDayPrevMonthForLastMonth = new Date(
        firstDayCurrentMonthForLastMonth.getTime() - 1
      );

      // Get the starting date of the previous month
      const firstDayPrevMonthForLastMonth = new Date(
        lastDayPrevMonthForLastMonth.getFullYear(),
        lastDayPrevMonthForLastMonth.getMonth(),
        1
      );

      // Format the starting and ending dates of the previous month as yyyy-mm-dd
      const startDateFormattedForLastMonth = firstDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForLastMonth = lastDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of last month: ${startDateFormattedForLastMonth}`
      // );
      // console.log(`Ending date of last month: ${endDateFormattedForLastMonth}`);
      setStartingDate(startDateFormattedForLastMonth);
      setEndingDate(endDateFormattedForLastMonth);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      // Get today's date
      const todayForCurrentMonth = new Date();

      // Get the first day of the current month
      const firstDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth(),
        1
      );

      // Get the last day of the current month
      const lastDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth() + 1,
        0
      );

      // Format the starting and ending dates of the current month as yyyy-mm-dd
      const startDateFormattedForCurrentMonth = firstDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForCurrentMonth = lastDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of current month: ${startDateFormattedForCurrentMonth}`
      // );
      // console.log(
      //   `Ending date of current month: ${endDateFormattedForCurrentMonth}`
      // );
      setStartingDate(startDateFormattedForCurrentMonth);
      setEndingDate(endDateFormattedForCurrentMonth);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  const handleChangeCustomStartingDate = (event) => {
    console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  const handleDeletePopup = (pID, quickbookid) => {
    console.log(pID, "pid==>");
    let rowdata = [];
    const newobj = {
      QuickBookID: quickbookid,
    };
    rowdata.push(newobj);
    const deleteRequestParam = {
      id: pID,
      //QuickBookID :quickbookid,
      // rowdata = {
      //   QuickBookID :quickbookid,
      // }
      loginuserid: loginuserid,
      quickbookarray: rowdata,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setShowDateFilterModal(true);
  };

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPage,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      locationid
    );
  };
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingdate,
    endingdate,
    locationid,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    axios
      .get(
        `${
          config.accountingBaseUrl
        }/chartofaccounts/journalselectall?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&startdate=${startingdate}&enddate=${endingdate}&locationid=${locationid}&loginId=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res, "this is a console");
        const filtereddata = res.data.ResponseData?.list?.map((item, index) => {
          return {
            SrNo: item.RowNumber,
            JournalNo: item.JournalNo,
            JournalDate: moment(item.JournalDate).format("YYYY-MM-DD"),
            DebitAmount: item.TotalDebitAmount,
            CreditAmount: item.TotalCreditAmount,
            Memo: item.Memo,
          };
        });
        setMappedData(filtereddata);
        setData(res.data.ResponseData?.list);
        console.log("HHELLO", res.data.ResponseData?.list);
        setRowCount(res.data.ResponseData?.list[0]?.TotalRecord);
        setColumnOrder(res.data.ResponseData?.ColumnOrder.split(","));

        const keysToSetFalse = res.data.ResponseData?.ColumnsHide || "";

        // Create default object with all values set to true
        const obj = columns.reduce((acc, item) => {
          acc[item.accessorKey] = true;
          return acc;
        }, {});

        // Comma-separated string of keys to set to false

        // Convert the string to an array and set the corresponding keys in the object to false
        keysToSetFalse.split(",").forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            obj[key] = false;
          }
        });

        setColumnVisibility(obj);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(
      1,
      perPage,
      e.target.value,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      locationid
    );
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(
      page,
      perPage,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      locationid
    );
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    handleListData(
      page,
      newPerPage,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      locationid
    );
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPage,
      searchtext,
      e.id,
      sortingDirection,
      startingDate,
      endingDate,
      locationid
    );
  };

  useEffect(() => {
    if (quickBookOptions?.value !== 2) {
      handleListData(
        1,
        perPage,
        searchtext,
        sortingId,
        sortingDirection,
        startingDate,
        endingDate,
        locationid,
        columnFilters,
        globalFilter,
        pagination,
        sorting
      );
    }
  }, [quickBookOptions, columnFilters, globalFilter, pagination, sorting]);

  useEffect(() => {
    if (quickBookOptions?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    // else if (quickBookOptions?.value == 2) {
    //   setStartingDate(customStartingDate);
    //   setEndingDate(customEndingDate);
    // }
    // Last Week Condition
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
      const currentWeekStartDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    //currentmonth
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  }, [quickBookOptions]);

  //cancel Delete popUp

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
  };

  const handleDateFilterConfirm = () => {
    console.log("api call delete");
    const deleteRequestParam = localStorage.getItem("DeleteRequestParam");
    console.log("deleteRequestParam: 12", deleteRequestParam);
    const deleteApiUrl = `${config.accountingBaseUrl}/chartofaccounts/journaldelete`;
    // console.log("deleteApiUrl: ", deleteApiUrl);
    axios
      .post(`${deleteApiUrl}`, deleteRequestParam, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then(() => {
        toastSuccess(DELETE_MESSAGE);
        // window.location.reload();
        window.location.href = window.location.href;
      });

    setShowDateFilterModal(false);
  };

  const handleexcelexport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(mappeddata);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `JournalDetails_.xlsx`);
  };

  const downloadPDF = (rows, field) => {
    setLoading(true);

    let newData = [];
    if (field === "selectedRow") {
      newData = rows.map((row) => row.original);
    } else if (field === "allData") {
      newData = data;
    }

    var doc = new jsPDF("p", "pt", "a4");

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
      if (i > 1) {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1.5rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Journal" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (startingDate) {
          content += "From: " + startingDate + " ";
          if (endingDate !== "") {
            content += "To: " + endingDate + " ";
          }
        } else {
          content += "All Data";
        }
      } else {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Journal" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (startingDate) {
          content += "From: " + startingDate + " ";
          if (endingDate !== "") {
            content += "To: " + endingDate + " ";
          }
        } else {
          content += "All Data";
        }
      }

      content += "</p>" + "</div>";

      // Printing table body
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; margin-top: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;">Sr.No.</th>' +
        '<th style="padding: 5px;">Journal No</th>' +
        '<th style="padding: 5px;">Journal Date</th>' +
        '<th style="padding: 5px; text-align: right;">Debit Amount</th>' +
        '<th style="padding: 5px; text-align: right; ">Credit Amount</th>' +
        '<th style="padding: 12px;   ">Memo</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            index +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            newData[index - 1].JournalNo +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(newData[index - 1].JournalDate).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(newData[index - 1].TotalDebitAmount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;text-align: right;">' +
            Number(newData[index - 1].TotalCreditAmount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 12px;">' +
            newData[index - 1].Memo +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Journal.pdf");
        setLoading(false);
      },
    });
  };

  const buttonPrint = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(data.length / 25); i++) {
      if (i > 1) {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1.5rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Journal" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (startingDate) {
          content += "From: " + startingDate + " ";
          if (endingDate !== "") {
            content += "To: " + endingDate + " ";
          }
        } else {
          content += "All Data";
        }
      } else {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Journal" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (startingDate) {
          content += "From: " + startingDate + " ";
          if (endingDate !== "") {
            content += "To: " + endingDate + " ";
          }
        } else {
          content += "All Data";
        }
      }

      content += "</p>" + "</div>";

      // Printing table body
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; margin-top: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;">Sr.No.</th>' +
        '<th style="padding: 5px;">Journal No</th>' +
        '<th style="padding: 5px;">Journal Date</th>' +
        '<th style="padding: 5px; text-align: right;">Debit Amount</th>' +
        '<th style="padding: 5px; text-align: right; ">Credit Amount</th>' +
        '<th style="padding: 12px;   ">Memo</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= data.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            index +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            data[index - 1].JournalNo +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(data[index - 1].JournalDate).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(data[index - 1].TotalDebitAmount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;text-align: right;">' +
            Number(data[index - 1].TotalCreditAmount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 12px;">' +
            data[index - 1].Memo +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
        setLoading(false);
      },
    });
  };

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `SalesbyCustomerDetail_.xlsx`);
  };

  const renderRowActionMenuItems = ({ row, table }) => [
    checkUserPermission(PERMISSION_EDIT) ? (
      <MenuItem
        key="edit"
        onClick={() => navigate(`/journal-entry/${row.original.ID}`)}
      >
        Edit
      </MenuItem>
    ) : (
      ""
    ),
    checkUserPermission(PERMISSION_DELETE) ? (
      <MenuItem
        className="confirm-text"
        to="#"
        // key="delete"
        title="Delete"
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={() =>
          handleDeletePopup(row.original.ID, row.original.QuickbookId)
        }
      >
        Delete
      </MenuItem>
    ) : (
      ""
    ),
  ];

  const renderTopToolbarCustomActions = ({ table }) => (
    <Box
      sx={{
        display: "flex",
        gap: "1rem",
        p: "0.5rem",
        flexWrap: "wrap",
      }}
    >
      {console.log(table, "tables")}

      {/* {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) &&
        (checkUserPermission("mark-inactive") ? (
          <Button
            // size="small"
            class="btn btn-sm btn-secondary"
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
            //only export selected rows
            onClick={() =>
              handleDeletePopup(
                "",
                "",
                table.getSelectedRowModel().rows,
                "multipleRowInactive"
              )
            }
            // startIcon={<FileDownloadIcon />}
            variant="contained"
          >
            Mark InActive
          </Button>
        ) : (
          " "
        ))} */}
      {/* <Button
        size="small"
        onClick={() =>
          setPagination({ ...pagination, pageSize: totalRows })
        }
        variant="contained"
      >
        Get All Data
      </Button> */}
    </Box>
  );

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Accounting: Journal</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Journal</li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-6 col-sm-12">
              <div className="d-flex flex-wrap mb-2">
                {/* <div className=" col-lg-2 col-md-6 col-sm-12">
                  <input
                    type="search"
                    placeholder="Search..."
                    className="search-btn form-control form-control-sm w-100 pull-right"
                    onChange={ChangeFilterText}
                    value={searchtext}
                  />
                </div> */}
                <div className="col-lg-2 col-md-6 col-sm-12 ml-3">
                  <Select
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange("ExcelExport", event);
                    }}
                    options={options}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    // hideSelectedOptions={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    id="ExcelExport"
                    name="ExcelExport"
                    className="custom-search-select"
                  />
                </div>
                {quickBookOptions?.value == 2 && (
                  <>
                    <div className=" col-lg-2 col-md-6 col-sm-12">
                      Custom Start Date:
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        id="StartDate"
                        name="StartDate"
                        onChange={(event) =>
                          handleChangeCustomStartingDate(event)
                        }
                      />
                    </div>
                    <div className="ml-2 col-lg-2 col-md-6 col-sm-12">
                      Custom End Date:
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        id="EndDate"
                        name="EndDate"
                        onChange={(event) =>
                          handleChangeCustomEndingDate(event)
                        }
                      />
                    </div>
                    <div className="ml-2 col-lg-1 col-md-6 col-sm-12 mt-4">
                      <button
                        className="btn btn-dark btn-sm"
                        onClick={() => handleSearchAccordingToDate()}
                      >
                        Search
                      </button>
                    </div>
                  </>
                )}
                {/* <div style={{ display: "flex", alignItems: "center", gap: "1rem" ,marginLeft:"40px" }}>
                  {checkUserPermission('export-excel-journal')&&
                  <button */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    marginLeft: "40px",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="">
                    {checkUserPermission("export-button") ? (
                      <button
                        // className="btn btn-added pull-right"
                        className="btn btn-sm btn-outline-dark btn-sm pull-right mr-3"
                        style={{ width: "max-content" }}
                        onClick={() => onBtExport([], "AllData")}
                      >
                        <i
                          className="fa fa-download mr-2"
                          style={{ color: "#111930" }}
                        ></i>
                        Export Visible Column
                        {/* <i class="fa-thin fa-download"></i> */}
                      </button>
                    ) : (
                      ""
                    )}
                    <Link
                      to="/journal-entry"
                      className="btn btn-sm btn-primary pull-right mr-2"
                    >
                      <i className="fa fa-plus me-2 lg"></i>
                      Entry Journal
                    </Link>
                  </div>
                  <div
                    className="cursor-pointer mt-1 mr-3"
                    onClick={() =>
                      handleSaveColumnOrder(
                        loginuserid,
                        "journal",
                        columnOrder,
                        token,
                        columnVisibility
                      )
                    }
                    title="Lock Your Sequence"
                    // onMouseEnter={() => setIcon(ColumnOrderIconHover)}
                    // onMouseLeave={() => setIcon(ColumnOrderIcon)}
                  >
                    <i class="fa fa-lock columnsLock fs-4"></i>
                  </div>
                  {/* } */}
                </div>
              </div>
            </div>
          </div>

          <CommonMatrialReactTableServerSideRender
            MainHeading="Sonar POS"
            ReportHeading="Journal List"
            columns={columns}
            data={data}
            // startdate={startdate}
            // enddate={enddate}
            columnGrouping={[]}
            columnsVisibility={{}}
            enableRowActions={
              checkUserPermission(PERMISSION_DELETE) ||
              checkUserPermission(PERMISSION_EDIT)
            }
            enableRowSelection={true}
            renderRowActionMenuItems={renderRowActionMenuItems}
            renderTopToolbarCustomActions={renderTopToolbarCustomActions}
            density="comfortable"
            showGlobalFilter={true}
            showColumnFilters={false}
            expanded={true}
            pagination={{ pageIndex: 0, pageSize: 25 }}
            rowCount={rowCount}
            setColumnFilters={setColumnFilters} // for termp comment filteron column
            setGlobalFilter={setGlobalFilter}
            setPagination={setPagination}
            setSorting={setSorting}
            setColumnOrder={setColumnOrder}
            setColumnVisibility={setColumnVisibility} //setColumnVisibility
            state={{
              columnFilters, // for termp comment filteron column
              // globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
              columnOrder,
              columnVisibility,
            }}
          />
        </div>
      </div>

      {/* popup for filter  */}
      <div
        className={`modal ${showDateFilterModal ? "d-block" : ""} `}
        style={{ background: "rgba(0,0,0, 0.4)" }}
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
          style={{ justifyContent: "center" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Confirmation</h6>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleDateFilterCancel}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <p>Are you sure you want to delete this record?</p>
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-center">
              {/* {checkUserPermission(PERMISSION_DELETE) ? ( */}

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleDateFilterConfirm()}
              >
                Delete
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleDateFilterCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* <DeleteConfirmationModal deleteApiUrl={`${config.accountingBaseUrl}/chartofaccounts/journaldelete`} /> */}
    </>
  );
};
